import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {
  GIFT_SHOP_PACKAGE_MAX_DURATION_DAYS,
  GIFT_SHOP_PACKAGE_MIN_DURATION_DAYS,
} from 'consts'
import {ButtonIcon, Label, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopSettingPackageFormBaseProps} from './GiftShopSettingPackageFormProps'

const StyledButton = styled(ButtonIcon)`
  background: ${({theme}) => theme.white_2};
  border: 1px solid ${({theme}) => theme.gray_1};
  box-shadow: none;
  border-radius: ${convertUnit(8)};
  color: ${({theme}) => theme.black_1};
`

export default function GiftShopSettingPackageFormDuration({
  form,
}: GiftShopSettingPackageFormBaseProps) {
  const {watch, setValue} = form
  const {duration} = watch()
  const {translate} = useTranslation()

  const handleAdjustDuration = useCallback(
    (delta: number) => {
      const newValue = Math.round(duration) + delta
      if (
        newValue < GIFT_SHOP_PACKAGE_MIN_DURATION_DAYS ||
        newValue > GIFT_SHOP_PACKAGE_MAX_DURATION_DAYS
      )
        return

      setValue('duration', newValue)
    },
    [duration, setValue],
  )

  return (
    <>
      <Label
        label={translate('giftShop:settingPackageDuration')}
        containerStyle={{
          marginTop: convertUnit(20),
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <StyledButton
            iconType="minus"
            onClick={() => {
              handleAdjustDuration(-1)
            }}
            backgroundColor="white_2"
            iconColor="black_1"
            disabled={duration <= 1}
            disableBackgroundColor="white_1"
            disableColor="danger_4"
          />
          <Paragraph fontSize="l">
            {duration} {translate('global:days')}
          </Paragraph>
          <StyledButton
            iconType="plus"
            onClick={() => {
              handleAdjustDuration(1)
            }}
            backgroundColor="white_2"
            iconColor="black_1"
            disabled={duration >= 5}
            disableBackgroundColor="white_1"
            disableColor="danger_4"
          />
        </div>
      </Label>
    </>
  )
}
